import { useState } from "react";
import { faqs } from "@/mocks/observeData";
import { SectionHeading, SectionShell } from "./common";

export default function FaqSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <SectionShell id="faq" className="bg-background-100/70 py-14 md:py-20">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1fr_1.6fr] lg:gap-16">
        <div>
          <SectionHeading
            eyebrow="FAQ"
            title="常见问题"
            desc="关于99黑料的内容口径、更新与转载规则，如果还有疑问，可通过下方反馈表单告诉我们。"
          />
          <div className="mt-8 hidden items-center gap-4 rounded-lg border border-accent-200 bg-accent-100/50 p-4 lg:flex">
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-accent-500 text-background-50">
              <i className="ri-question-line text-xl" />
            </span>
            <p className="text-sm text-accent-900">
              你的疑问也是读者的疑问，<span className="font-bold">把问题发给我们</span>，我们会整理进公开FAQ。
            </p>
          </div>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((f, i) => {
            const open = openIdx === i;
            return (
              <div
                key={f.q}
                className={`overflow-hidden rounded-lg border bg-background-50 transition-colors ${
                  open ? "border-primary-200" : "border-background-200"
                }`}
              >
                <button
                  type="button"
                  aria-expanded={open}
                  onClick={() => setOpenIdx(open ? null : i)}
                  className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <span className={`font-heading text-base font-bold md:text-lg ${open ? "text-primary-700" : "text-foreground-950"}`}>
                    {f.q}
                  </span>
                  <span
                    className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-colors ${
                      open ? "bg-primary-500 text-background-50" : "bg-background-100 text-foreground-600"
                    }`}
                  >
                    <i className={`ri-${open ? "subtract-line" : "add-line"} text-lg`} />
                  </span>
                </button>
                {open && (
                  <div className="border-t border-background-200 px-5 py-4">
                    <p className="text-sm leading-relaxed text-foreground-600">{f.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </SectionShell>
  );
}